module.exports = __webpack_public_path__ + "static/security-297676c40a6ae646bbefe6af6a724c3f.jpg";